import { Input, Text } from "@fluentui/react-components";
import { sessions } from "@strings/index";
import * as React from "react";
import { useStyles } from "./OfficeActionFields.styles";

const sessionStr = sessions();

type Props = {
  applicationId: string;
  onApplicationIdChange: (value: string) => void;
};

export const OfficeActionFields: React.FC<Props> = ({ applicationId, onApplicationIdChange }) => {
  const styles = useStyles();
  return (
    <>
      <Input
        size="medium"
        className={styles.field}
        placeholder={sessionStr.applicationIdPlaceholder}
        value={applicationId}
        onChange={(_event, data) => onApplicationIdChange(data.value)}
      />
      <Text className={styles.helpText}>{sessionStr.applicationIdHelpText}</Text>
    </>
  );
};
